module.exports = __webpack_public_path__ + "a1d205e3965ecda7fdf44b54e11537bd.png";